<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: 'App',
}
</script>
<style>
@import './assets/style.css';
@import './assets/style.scss';

* {
  padding: 0;
  margin: 0;
}

/*滚动条样式*/
::-webkit-scrollbar {
  width: 6px;
}

::-webkit-scrollbar-track {
  width: 6px;
  background: rgba(#101f1c, 0.1);
  /*  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em; */
}

::-webkit-scrollbar-thumb {
  background-color: rgba(144, 147, 153, 0.5);
  background-clip: padding-box;
  min-height: 28px;
  /*  -webkit-border-radius: 2em;
  -moz-border-radius: 2em;
  border-radius: 2em; */
  transition: background-color 0.3s;
  cursor: pointer;
}

::-webkit-scrollbar-thumb:hover {
  background-color: rgba(144, 147, 153, 0.3);
}
</style>
